import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { ConstantsService } from '../common/services/constants.service';

const httpOptions = {     
    headers: new HttpHeaders({        
        'Content-Type':  'application/json;charset=utf-8', 
        'Authorization': ConstantsService.AUTH_TOKEN
    })    
};


@Injectable()
export class OtpService {

    constructor(private http: HttpClient) { }

    otpverify(rootUrl:string, usercode: string, userid:number, subuserid:number, student_id:number, otp: string, exam_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'student/loginOtp', {usercode:usercode, user_id:userid, sub_user_id:subuserid, student_id:student_id, otp:otp, exam_id:exam_id}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }

    resendOpt(rootUrl:string, usercode: string, userid:number, subuserid:number, student_id:number, exam_id: string):Observable<any> {
        return this.http.post<any>(rootUrl+'student/otp/resend', {usercode:usercode, user_id:userid, sub_user_id:subuserid, student_id:student_id, exam_id:exam_id}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }

    /** 
*  resendveryfyotp
*/
    resendVeryfyOtp(rootUrl: string,id_self_student: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/resendMobileOtp', { id_self_student: id_self_student }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }

   /** 
*  veryfyotp
*/
    otpverifyforgotpass(rootUrl: string,otp_type:number,otp:string, id_student: number, username: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/verifyOTP', { id_student: id_student,otp:otp,otp_type:otp_type, username: username }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }   
    checkotp(rootUrl: string, id_self_student:number, otp_type:number, otp: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/verifyOtp', {  id_self_student: id_self_student, otp_type: otp_type, otp: otp }, httpOptions)
            .pipe(map(user => {
            return user;
            }));
    }     
    otpautoregister(rootUrl: string, id_self_student:number, otp_type:number, otp: string, id_student:number): Observable<any> {
    return this.http.post<any>(rootUrl + 'studentSelf/verifyOtp', {  id_self_student: id_self_student, otp_type: otp_type, otp: otp, id_student: id_student }, httpOptions)
        .pipe(map(user => {
        return user;
        }));
    }    
}